import React, { Fragment } from 'react';
import { useLocation, NavLink } from 'react-router-dom';

import { SecondaryNav } from 'containers/app/components/secondary-navigation-bar';

import SecondaryNavBar from '../../nav-bar/secondary-nav-bar';
import { NavBarMenu } from '../../nav-bar/secondary-nav-bar.styled';

const SubLinks = ({ links, isDisabled }) => {
    const { pathname } = useLocation();

    if (isDisabled || !links.length) {
        return null;
    }

    return (
        <SecondaryNavBar>
            <SecondaryNav align="right">
                {links.map(({ menu, path, subPath }, index) => {
                    const isActive =
                        subPath?.some(({ path: sub }) => pathname.includes(sub)) || pathname.includes(path);

                    return (
                        // eslint-disable-next-line react/no-array-index-key -- TODO: legacy index key (baseline)
                        <Fragment key={index}>
                            <NavLink className="nav-link" to={path}>
                                <NavBarMenu isActive={isActive}>{menu}</NavBarMenu>
                            </NavLink>

                            {index !== links.length - 1 && <>&nbsp;/&nbsp;</>}
                        </Fragment>
                    );
                })}
            </SecondaryNav>
        </SecondaryNavBar>
    );
};

export default SubLinks;
